// Auto-generated FAQ answers per product, derived from real spec data so the
// FAQPage schema never drifts from what the PDP actually says.
// These are industry-standard answers — review and tweak per product.
import { PRODUCT_SPECS } from "./product_specs";

const spec = (id, label) => {
  const s = PRODUCT_SPECS[id];
  if (!s) return null;
  const all = [...(s.coreSpecs || []), ...(s.performance || [])];
  const hit = all.find((r) => r.label.toLowerCase().includes(label.toLowerCase()));
  return hit ? hit.value : null;
};

const HEATING_OK = /engineered|hybrid|tile|stone|porcelain|terrazzo/i;
const WET_OK = /tile|stone|porcelain|terrazzo|hybrid|vinyl/i;

/**
 * Three questions per product, phrased the way people actually search and ask
 * assistants. Answers pull live values from product_specs.
 */
export function productFaqs(product) {
  if (!product) return [];
  const id = product.id;
  const d = (product.discipline || "").toLowerCase();
  const name = product.name;

  const wear = spec(id, "wear layer") || spec(id, "thickness");
  const warranty = spec(id, "warranty");
  const slip = spec(id, "slip");
  const janka = spec(id, "janka");
  const install = spec(id, "install");
  const origin = spec(id, "origin") || spec(id, "provenance");

  const faqs = [];

  // 1 · Underfloor heating — one of the most searched flooring questions
  const heatOk = HEATING_OK.test(d) || HEATING_OK.test(name);
  faqs.push({
    q: `Can ${name} be installed over underfloor heating?`,
    a: heatOk
      ? `Yes. ${name} is dimensionally stable enough for hydronic or electric underfloor heating, provided the surface temperature stays below 27°C and the system is commissioned gradually before and after installation. Our studio will confirm the build-up for your specific slab.`
      : `${name} is not recommended over underfloor heating. Speak to the studio in Drummoyne and we will specify an alternative from the same tonal family that performs over a heated slab.`,
  });

  // 2 · Wet areas / performance
  const wetOk = WET_OK.test(d) || WET_OK.test(name);
  faqs.push({
    q: `Is ${name} suitable for bathrooms, kitchens or other wet areas?`,
    a: wetOk
      ? `Yes.${slip ? ` It carries a slip rating of ${slip},` : ""} which suits wet and internal-external transition areas when installed with the correct substrate preparation and waterproofing to AS 3740.`
      : `${name} suits living areas, bedrooms and hallways rather than wet areas. For bathrooms and laundries we would specify a tile or stone from the collection that shares the same tone.`,
  });

  // 3 · Specification detail — the question architects and builders actually ask
  if (wear || janka) {
    faqs.push({
      q: `What are the key specifications for ${name}?`,
      a: [
        wear ? `Wear layer / thickness: ${wear}.` : null,
        janka ? `Janka hardness: ${janka}.` : null,
        install ? `Installation: ${install}.` : null,
        warranty ? `Warranty: ${warranty}.` : null,
        origin ? `Origin: ${origin}.` : null,
      ]
        .filter(Boolean)
        .join(" ") + ` Full specification and samples are available from the Drummoyne studio.`,
    });
  } else {
    faqs.push({
      q: `How do I see ${name} in person?`,
      a: `Full-size samples of ${name} are available at the My Floor Studio showroom at 184 Victoria Road, Drummoyne, or can be sent to your project address after a short consultation so we confirm the right pieces for your space.`,
    });
  }

  return faqs;
}
